import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledContactUsHookForExport = styled(Flex)`
    padding: 0 8px;
`;
